/** Valor de celda como texto plano (ordenar / filtrar en tabla). */
export function stripHtml(html: unknown): string {
  if (html == null || html === "") return "";
  const str = String(html);
  if (typeof document !== "undefined") {
    const div = document.createElement("div");
    div.innerHTML = str;
    return (div.textContent || div.innerText || "").trim();
  }
  return str.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}

export function userCellText(row: { user?: { first_name?: string; last_name?: string; dni?: string } }): string {
  const u = row?.user;
  if (!u) return "";
  return [u.first_name, u.last_name, u.dni].filter(Boolean).join(" ").trim();
}

export function nestedName(row: { reason?: { name?: string } }, field = "reason"): string {
  const obj = (row as Record<string, { name?: string } | undefined>)?.[field];
  return obj?.name?.trim() ?? "";
}
